import React from 'react';
import { useLocalStorageBoolean } from 'react-use-window-localstorage';
import ScrollEffect from './animations/components/scroll-effect';
import Button from './primitives/button';

const SingleLocationLazy = React.lazy(
    () => import('./single-location-component'),
);

const SingleLocationMap = ({ location }: { location: { lat: number, long: number } }): JSX.Element => {
    const defaultValue = true;
    const [acceptSingleMap, setAcceptSingleMap] = useLocalStorageBoolean(
        'boolValue',
        defaultValue,
    );

    return (
        <ScrollEffect css={{ width: '100%', height: '100%' }}>
            <div
                css={{
                    width: '100% !important',
                    height: '100% !important',
                    overflow: 'hidden !important',
                }}
            >
                <div
                    css={{
                        width: '100%',
                        height: '100%',
                        position: 'relative',
                        borderRadius: '16px',
                        overflow: 'hidden',
                    }}
                >
                    {acceptSingleMap === true ? (
                        <div
                            css={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <div
                                css={{
                                    backgroundColor: 'var(--color-gray-hellgrau)',
                                    display: 'flex',
                                    height: '100%',
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                    padding: '45px',
                                }}
                            >
                                <div
                                    css={{
                                        width: '100%',
                                    }}
                                >
                                    <p
                                        className="p2"
                                        css={{
                                            textAlign: 'center',
                                            paddingBottom: '40px',
                                            width: '100%',
                                            paddingLeft: '35px',
                                            paddingRight: '35px',
                                            '@media (max-width: 767px)': {
                                                paddingLeft: '0',
                                                paddingRight: '0',
                                                flexDirection: 'column',
                                                paddingBottom: '40px',
                                            },
                                        }}
                                    >
                                        Für diese Funktion ist das Laden von Inhalten von Google
                                        Maps nötig. Hierbei werden sowohl Daten von Google Servern
                                        heruntergeladen, als auch Nutzungsinformationen durch Google
                                        erhoben.
                                    </p>
                                </div>
                                <div
                                    css={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Button
                                        onClick={() => setAcceptSingleMap(false)}
                                        css={{
                                            background: 'var(--color-blue-dunkelblau)',
                                            color: 'white',
                                            padding: '10px 20px',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        Inhalte von Google laden
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <React.Suspense fallback={null}>
                            <SingleLocationLazy location={location} />
                        </React.Suspense>
                    )}
                </div>
            </div>
        </ScrollEffect>
    );
};

export default SingleLocationMap;
